import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router';
import { IconButton, Tooltip } from '@mui/material';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import HomeIcon from '@mui/icons-material/Home';
import PaletteIcon from '@mui/icons-material/Palette';
import CollectionsIcon from '@mui/icons-material/Collections';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import GroupIcon from '@mui/icons-material/Group';
import EventIcon from '@mui/icons-material/Event';
import { useUser } from '../../components/UserContext';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

//License Check
import type { LicenseCheck } from "../../models/License";
import { useLicenseChecker } from '../../hooks/useLicenseCheck';
import LicenseExceededDialog from "../../components/LicenseManagement/LicenseExceededDialog";

//Dialogs
import ArtworkManagement from "../../components/ArtworkManagement/ArtworkManagement";

export const BottomBar: React.FC = () => {
    const navigate = useNavigate();
    const isAuthenticated = useIsAuthenticated();
    const { user } = useUser();

    //License Checker
    const { canAdd } = useLicenseChecker();
    const [licenseCheck, setLicenseCheck] = useState<LicenseCheck | null>(null);
    const isTenantAdmin = true;
    const [licenseDialogOpen, setLicenseDialogOpen] = useState(false);

    //Add Artwork
    const [openModal, setOpenModal] = useState(false);

    const handleAddArtwork = async () => {
        const result = await canAdd("artwork");

        if (!result.allowed) {
            setLicenseCheck(result);
            setLicenseDialogOpen(true);
            return;
        }

        // Add New Arrtwork
        setOpenModal(true);
    };

    const handleUpgrade = () => {
        setLicenseDialogOpen(false);
        navigate("/admin/tenant");
    };

    const handleClose = () => setOpenModal(false);
    const [refreshGallery, setRefreshGallery] = useState(false);
    const handleSaveComplete = () => {
        setOpenModal(false);
        setRefreshGallery(prev => !prev);
    };

    return (
        <>
            <nav className="bottombar">
                <button className="bottom-tab" onClick={() => navigate('/')}>
                    <HomeIcon className="bottom-icon" />
                    <span>Home</span>
                </button>
                {isAuthenticated && user?.hasAcceptedTerms ? (
                    <>
                <button className="bottom-tab" onClick={() => navigate('/gallery')}>
                    <CollectionsIcon className="bottom-icon" />
                    <span>Gallery</span>
                </button>
                        <button className="bottom-tab" onClick={() => navigate('/events/view')}>
                            <EventIcon className="bottom-icon" />
                    <span>Calendar</span>
                </button>
                <button className="bottom-tab" onClick={() => navigate('/settings/artists')}>
                        <GroupIcon className="bottom-icon" />
                    <span>Artists</span>
                </button>
                    <button className="bottom-tab" onClick={handleAddArtwork}>
                    <AddToPhotosIcon />
                    <span>Add Artwork</span>
                </button>
                    </>
                ) : (
               <></>
                )}

        </nav>

            <ArtworkManagement isOpen={openModal} onClose={handleClose} onSaveComplete={handleSaveComplete} artworkId={null} />

            {/* License Position Dialog */}
            <LicenseExceededDialog
                open={licenseDialogOpen}
                onClose={() => setLicenseDialogOpen(false)}
                licenseCheck={licenseCheck}
                onUpgrade={handleUpgrade}
                isTenantAdmin={isTenantAdmin}
            />
        </>
    );
};
